import state from './moduleShopDrawingsState';
import mutations from './moduleShopDrawingsMutations';
import actions from './moduleShopDrawingsActions';
import getters from './moduleShopDrawingsGetters';

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
